import type { StepActor, StepStatus } from "../flow/types";

export const STATUS_META: Record<
  StepStatus,
  { label: string; color: string; bg: string; border: string; dot: string; ring: string }
> = {
  pending: { label: "Pending", color: "gray.500", bg: "white", border: "gray.200", dot: "gray.300", ring: "rgba(160,174,192,0.25)" },
  running: { label: "Running", color: "blue.600", bg: "blue.50", border: "blue.300", dot: "blue.500", ring: "rgba(66,153,225,0.3)" },
  waiting: { label: "Waiting for event", color: "orange.600", bg: "orange.50", border: "orange.300", dot: "orange.400", ring: "rgba(237,137,54,0.3)" },
  completed: { label: "Completed", color: "green.600", bg: "white", border: "green.200", dot: "green.500", ring: "rgba(72,187,120,0.3)" },
  failed: { label: "Failed", color: "red.600", bg: "red.50", border: "red.300", dot: "red.500", ring: "rgba(245,101,101,0.3)" },
  skipped: { label: "Skipped", color: "gray.500", bg: "gray.50", border: "gray.200", dot: "gray.400", ring: "rgba(160,174,192,0.25)" },
};

export const ACTOR_META: Record<StepActor, { label: string; colorScheme: string }> = {
  ORCA: { label: "OrCA", colorScheme: "blue" },
  CUSTOMER: { label: "Customer", colorScheme: "teal" },
  SUPPLIER: { label: "Supplier", colorScheme: "purple" },
  EVENT: { label: "Event", colorScheme: "orange" },
};

export const formatClock = (ts?: number) =>
  ts ? new Date(ts).toLocaleTimeString([], { hour12: false }) + "." + String(ts % 1000).padStart(3, "0") : "–";

export const copyText = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const el = document.createElement("textarea");
    el.value = text;
    document.body.appendChild(el);
    el.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(el);
    return ok;
  }
};

export const pretty = (value: unknown) => {
  if (value === undefined) return "—";
  if (typeof value === "string") return value;
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
};
